import React, { useEffect, useState } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Header } from "./Header";
import { SideNav } from "./SideNav";
import { Backdrop } from "@material-ui/core";
import { useAppSelector } from "src/app-redux/hooks";
import { selectStatus } from "src/app-redux/auth/authSlice";
import CommonLoader from "../Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      height: "100vh",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 2,
      color: "#fff",
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      maxHeight: "100vh",
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      overflowX: "auto",
      zIndex: theme.zIndex.modal - 1,
    },
    hidden: {
      overflow: "hidden",
      background: "red",
    },
  })
);

interface Props {
  children: React.ReactNode;
}

export function Layout(props: Props) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => setOpen((prev) => !prev);
  const status = useAppSelector(selectStatus);

  useEffect(() => {
    if (document.body.classList.contains("hidden")) {
      document.body.classList.remove("hidden");
    }
  });
  return (
    <>
      <Backdrop className={classes.backdrop} open={status == "loading"}>
        <CommonLoader />
      </Backdrop>
      <div className={classes.root}>
        <Header open={open} toggleDrawer={toggleDrawer} />
        <SideNav open={open} toggleDrawer={toggleDrawer} />
        <main id="main-scrollable-element" className={classes.content}>
          <div className={classes.toolbar} />
          {props.children}
        </main>
      </div>
    </>
  );
}
